import { makeStyles, createStyles } from '@material-ui/core/styles';

const footStyle = makeStyles(() =>
  createStyles({
    footer: {
      background: '#000',
      padding: '20px 0',
      position: 'absolute',
      bottom: 0,
      left: '0',
      width: '100%',
    },
    footCont: {
      maxWidth: '82.5rem',
      width: '100%',
      margin: '0 auto',
      textAlign: 'center',
      color: '#858585',
      fontSize: '14px',
    },
  })
);

export default footStyle;
